import { FormTextArea } from "../../../components/ui-lib/form/FormTextArea";
import { FormWizardStepProps } from "../../../models/form-wizard-step-props";
import { VacancyFormFields } from "../VacancyCreateWizard";

function DescriptionStep({
  control,
  register,
  errors,
}: FormWizardStepProps<VacancyFormFields>) {
  return (
    <div className="flex h-full w-full items-center justify-center">
      <div className="space-y-4">
        <h2
          className="text-center text-th-primary-900"
          data-cy="wizard-step-title"
        >
          Bemerkungen / Hinweise zur Vertretungsstelle
        </h2>
        <FormTextArea
          label="Besondere Hinweise"
          id="description"
          name="description"
          rows={5}
          register={register}
          errors={errors as any}
          showLabel={false}
        ></FormTextArea>
      </div>
    </div>
  );
}

export default DescriptionStep;
